import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import TableHeader from "../../../../components/Tables/TableHeader";
import { Link } from "react-router-dom";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../../components/Tables/SimpleTableHeader";
import TableHeaderAdv from "../../../../components/Tables/TableHeaderAdv";

function TableComponent({ Registers }) {
  const { logout } = StaffuseAuth();

  //----------------------------------Nested Sorting--------------------------------------------
  // State to track sort field and direction
  const [sortConfig, setSortConfig] = useState({
    field: "",
    direction: "",
    nest: "",
  });

  let sortedRegisters = React.useMemo(() => {
    let sortableItems = [...Registers];
    if (
      sortConfig.field === "" &&
      sortConfig.direction === "" &&
      sortConfig.nest === ""
    ) {
      sortableItems.sort((a, b) => {
        if (
          a.SEFInfo?.Staff_Assigned &&
          a.SEFInfo?.Staff_Assigned !== "" &&
          a.SEFInfo?.Staff_Assigned !== undefined &&
          a.SEFInfo?.Staff_Assigned !== null &&
          (!b.SEFInfo?.Staff_Assigned ||
            b.SEFInfo?.Staff_Assigned === "" ||
            b.SEFInfo?.Staff_Assigned === undefined ||
            b.SEFInfo?.Staff_Assigned === null)
        ) {
          return -1;
        } else if (
          b.SEFInfo?.Staff_Assigned &&
          b.SEFInfo?.Staff_Assigned !== "" &&
          b.SEFInfo?.Staff_Assigned !== undefined &&
          b.SEFInfo?.Staff_Assigned !== null &&
          (!a.SEFInfo?.Staff_Assigned ||
            a.SEFInfo?.Staff_Assigned === "" ||
            a.SEFInfo?.Staff_Assigned === undefined ||
            a.SEFInfo?.Staff_Assigned === null)
        ) {
          return 1;
        } else if (
          a.SEFInfo?.SEFSubmissionDate > b.SEFInfo?.SEFSubmissionDate
        ) {
          return 1;
        } else if (
          a.SEFInfo?.SEFSubmissionDate <= b.SEFInfo?.SEFSubmissionDate
        ) {
          return -1;
        } else {
          return 0;
        }
      });
    } else if (sortConfig.field === "_id") {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.field] < b[sortConfig.field]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.field] > b[sortConfig.field]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    } else if (sortConfig.field !== null && sortConfig.field !== "") {
      sortableItems.sort((a, b) => {
        const aValue = a[sortConfig.nest]?.[sortConfig.field] ?? "";
        const bValue = b[sortConfig.nest]?.[sortConfig.field] ?? "";
        if (aValue.toLowerCase() < bValue.toLowerCase()) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue.toLowerCase() > bValue.toLowerCase()) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [Registers, sortConfig]);

  const requestSortAdv = (field, nest) => {
    let direction = "ascending";
    if (sortConfig.field === field && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ field, direction, nest });
  };

  //--------------------------color stuff-----------------------------------------
  //Find the number of values in Attendee, nested or not nested, that are red, green, blue, or amber
  function getColor(Attendee) {
    if (
      !Attendee.SEFInfo?.SEF ||
      Attendee.SEFInfo?.SEF === "Incomplete" ||
      Attendee.SEFInfo?.SEF === "In_Progress" ||
      Attendee.SEFInfo?.SEF === "" ||
      Attendee.SEFInfo?.SEF === undefined ||
      Attendee.SEFInfo?.SEF === null
    ) {
      return null;
    }
    let redCount = 0;
    Object.entries(Attendee).forEach(([key, value]) => {
      if (typeof value === "object") {
        Object.entries(value).forEach(([key2, value2]) => {
          if (value2 === "Red") {
            redCount++;
          }
        });
      } else {
        if (value === "Red") {
          redCount++;
        }
      }
    });
    let amberCount = 0;
    Object.entries(Attendee).forEach(([key, value]) => {
      if (typeof value === "object") {
        Object.entries(value).forEach(([key2, value2]) => {
          if (value2 === "Amber") {
            amberCount++;
          }
        });
      } else {
        if (value === "Amber") {
          amberCount++;
        }
      }
    });
    let greenCount = 0;
    Object.entries(Attendee).forEach(([key, value]) => {
      if (typeof value === "object") {
        Object.entries(value).forEach(([key2, value2]) => {
          if (value2 === "Green") {
            greenCount++;
          }
        });
      } else {
        if (value === "Green") {
          greenCount++;
        }
      }
    });
    let blueCount = 0;
    Object.entries(Attendee).forEach(([key, value]) => {
      if (typeof value === "object") {
        Object.entries(value).forEach(([key2, value2]) => {
          if (value2 === "Blue") {
            blueCount++;
          }
        });
      } else {
        if (value === "Blue") {
          blueCount++;
        }
      }
    });
    let topLevelColor = "";
    if (redCount > 0) {
      topLevelColor = "Red";
    } else if (amberCount > 0) {
      topLevelColor = "Amber";
    } else if (greenCount > 0) {
      topLevelColor = "Green";
    } else if (blueCount > 0) {
      topLevelColor = "Blue";
    } else {
      topLevelColor = "Grey";
    }

    return topLevelColor;
  }

  //-----------------------------Return---------------------------------------------

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "95%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        View Register
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              <>
                {TableHeaderAdv(
                  "Submission Date",
                  requestSortAdv,
                  "SEFSubmissionDate",
                  "SEFInfo"
                )}
              </>
              <>
                {TableHeaderAdv(
                  "Assigned",
                  requestSortAdv,
                  "Staff_Assigned",
                  "SEFInfo"
                )}
              </>

              <>
                {TableHeaderAdv(
                  "Name",
                  requestSortAdv,
                  "First_Name",
                  "BasicInfo"
                )}
              </>
              <>
                {TableHeaderAdv(
                  "ProgrammeTitle",
                  requestSortAdv,
                  "ProgrammeTitle",
                  "BasicInfo"
                )}
              </>
              <>
                {TableHeaderAdv(
                  "ProgrammeDate",
                  requestSortAdv,
                  "ProgrammeDate",
                  "BasicInfo"
                )}
              </>
              <>{SimpleTableHeader("Accom")}</>
              <>
                {TableHeaderAdv(
                  "ProgrammeVarient",
                  requestSortAdv,
                  "ProgrammeVarient",
                  "BasicInfo"
                )}
              </>
              <>{SimpleTableHeader("Color")}</>
              <>{SimpleTableHeader("View Attendee")}</>
              <>
                {TableHeaderAdv("Review SEF", requestSortAdv, "SEF", "SEFInfo")}
              </>
              <></>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedRegisters.map((Register, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor:
                    Register?.MetaData?.Archived === "Yes"
                      ? "rgba(139, 0, 0, 0.5)"
                      : "",
                  "&:hover": {
                    backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                    "& .MuiTableCell-root": {
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word", // Adjust padding here to make cells smaller
                    },
                  },
                }}
              >
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.SEFInfo &&
                    Register.SEFInfo.SEFSubmissionDate
                      ? Register.SEFInfo.SEFSubmissionDate
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.SEFInfo &&
                    Register.SEFInfo.Staff_Assigned
                      ? Register.SEFInfo.Staff_Assigned
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.First_Name
                      ? Register.BasicInfo.First_Name
                      : ""}{" "}
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.Last_Name
                      ? Register.BasicInfo.Last_Name
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeTitle
                      ? Register.BasicInfo.ProgrammeTitle
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeDate
                      ? Register.BasicInfo?.ProgrammeDate ===
                        "(7th July - 18th July 2025)"
                        ? "Young 1"
                        : Register.BasicInfo?.ProgrammeDate ===
                          "(28th July - 8th August 2025)"
                        ? "Young 2"
                        : Register.BasicInfo?.ProgrammeDate ===
                          "(18th August - 29th August 2025)"
                        ? "Young 3"
                        : Register.BasicInfo.ProgrammeDate
                      : "..."}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeVarient
                      ? Register.BasicInfo?.ProgrammeVarient
                        ? Register.BasicInfo?.ProgrammeVarient.toLowerCase().includes(
                            "accom"
                          )
                          ? "Accom"
                          : "Non Accom"
                        : Register.BasicInfo.ProgrammeVarient
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeVarient
                      ? Register.BasicInfo.ProgrammeVarient
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      fontFamily: "Arial",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      backgroundColor:
                        getColor(Register) === "Red"
                          ? "#d11212"
                          : getColor(Register) === "Amber"
                          ? "#f98007"
                          : getColor(Register) === "Green"
                          ? "#06862f"
                          : getColor(Register) === "Blue"
                          ? "#0853b6"
                          : getColor(Register) === "Grey"
                          ? "Grey"
                          : "",
                    }}
                  >
                    {getColor(Register)}
                  </TableCell>
                </>
                {/* New TableCell for update action using Link */}
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <Link
                    to={`/Staff/ViewAttendee/${Register._id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button>View</button>
                  </Link>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {Register.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
                    "summer"
                  ) ? (
                    <>
                      <Link
                        to={`/Staff/ViewSEFReview/${Register._id}`}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                      >
                        <button
                          style={{
                            textDecoration: "none",
                            backgroundColor: !Register.SEFInfo?.SEF
                              ? "#d11212"
                              : Register.SEFInfo?.SEF === "Incomplete"
                              ? "#d11212"
                              : Register.SEFInfo?.SEF === "In_Progress"
                              ? "#0853b6"
                              : Register.SEFInfo?.SEF === "Awaiting_Review"
                              ? "#f98007"
                              : Register.SEFInfo?.SEF === "Complete"
                              ? "#06862f"
                              : "",
                          }}
                        >
                          SEF{" "}
                          {Register.SEFInfo?.SEF
                            ? Register.SEFInfo?.SEF.replaceAll("_", " ")
                            : "Not Started"}
                        </button>
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TableComponent;
